import type { AppConfig } from "../../types/appConfig";
import { expectStatuses, fetchZekay } from "../zekay/httpClient";

export class NewsletterModel {
  private zekayAPI: string;

  constructor(config: AppConfig) {
    this.zekayAPI = config.zekayAPI;
  }

  async unregisterNewsletter(email: string, companyId: number): Promise<void> {
    const response = await fetchZekay(`${this.zekayAPI}/newsletter/unregister`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, company_id: companyId, rgpd_consent: false }),
    });
    await expectStatuses(response, 204);
  }
}
